<template>
  <div>
    <v-autocomplete
      ref="auto"
      v-model="faixa.faixaId"
      item-text="faixaNome"
      item-value="faixaid"
      :items="faixas"
      label="Faixa"
      placeholder="Faixa"
      clearable
      :loading="loading"
    >
      <template slot="no-data">
        <div class="progress" v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div v-else>Nenhuma Faixa retornada</div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { faixaApi } from "@/apis";

export default {
  name: "ComboboxFaixas",
  props: {
    faixa: null,
  },
  data() {
    return {
      faixas: [],
      loading: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.loading = true;
      faixaApi
        .list()
        .then((resp) => {
          this.faixas = resp.data;

          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error("Erro ao obter faixas");
        });
    },
  },
};
</script>
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
